import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { BillingDataStore } from '../../billing-data/billing-data.store';
import { ErrorService } from '../../error-reporting/error.service';
import { catchError, filter, mapTo, take, tap } from 'rxjs/operators';
import { BillingDataDispatcher } from '../../billing-data/billing-data.dispatcher';
import { RenewalInfo } from '../../billing-data/models/renewal-info.model';

@Injectable()
export class RenewalInfoGuard implements CanActivate, CanActivateChild {
  constructor(
    private _errorService: ErrorService,
    private _billingDataStore: BillingDataStore,
    private _billingDataDispatcher: BillingDataDispatcher
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.checkStore();
  }

  canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.canActivate(route, state);
  }

  checkStore(): Observable<boolean> {
    return this._billingDataStore.renewalInfo$.pipe(
      tap((renewalInfo: RenewalInfo) => {
        if (!renewalInfo) {
          this._billingDataDispatcher.fetchRenewalInfo();
        }
      }),
      filter((x) => !!x),
      take(1),
      mapTo(true),
      catchError((error) => {
        this._errorService.alertSystem(
          new Error(`renewal info guard error`),
          error
        );

        return of(false);
      })
    );
  }
}
